var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Driver ico"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "SF 60x60@2x",
    fill: "#fff",
    stroke: "#eaeaea"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "person info ico"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 110",
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 110",
    d: "M18.425 19c-2.761 0-5-3.239-5-6v-1a5 5 0 015-5 5 5 0 015 5v1c0 2.761-2.239 6-5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 111",
    d: "M19.425 25a7.958 7.958 0 011.015-3.894A19.57 19.57 0 0018.425 21a22.229 22.229 0 00-6.974 1.193 2.99 2.99 0 00-2.026 2.839V29h11.079a7.955 7.955 0 01-1.079-4z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 112",
    transform: "translate(9.425 7)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 112",
    d: "M18 12a6 6 0 106 6 6.018 6.018 0 00-6-6z",
    fill: "#ef5323"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 124",
    fill: "#fff",
    d: "M17 17h2v5h-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 20",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(17 14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 113",
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 113",
    d: "M18.425 19c-2.761 0-5-3.239-5-6v-1a5 5 0 015-5 5 5 0 015 5v1c0 2.761-2.239 6-5 6z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 114",
    d: "M19.425 25a7.958 7.958 0 011.015-3.894A19.57 19.57 0 0018.425 21a22.229 22.229 0 00-6.974 1.193 2.99 2.99 0 00-2.026 2.839V29h11.079a7.955 7.955 0 01-1.079-4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9770cd8f639d60459e53a2fbd211f76c.svg";
export { ForwardRef as ReactComponent };